export const toUtf8 = (input) => new TextDecoder("utf-8").decode(input);
